var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { ChildComponent } from "../../../pages/modules/child-component";
import { BrandingType } from "../../../../services/modules/brand-client.service";
import * as Enumerable from "linq";
var BrandingBase = /** @class */ (function (_super) {
    __extends(BrandingBase, _super);
    function BrandingBase(notificationService, i18N, brandClientService, bindingEngine, eventAggregator, tokenClient, bindingSignaler) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.brandClientService = brandClientService;
        _this.bindingEngine = bindingEngine;
        _this.eventAggregator = eventAggregator;
        _this.tokenClient = tokenClient;
        _this.bindingSignaler = bindingSignaler;
        _this.subscriptions = [];
        _this.allKeys = [];
        _this.keys = [];
        return _this;
    }
    BrandingBase.prototype.onActivated = function (model) {
        var _this = this;
        this.keys = []; // clear observers
        this.model = null; // clear observers
        if (model) {
            this.isWidget = model.isWidget;
            this.templateName = model.templateName;
            this.themeName = model.themeName;
            this.isManagingDefaultConfig = model.isManagingDefaultConfig;
            // if it's a super admin then, that means he will be modifying the default config
            // if it's a brand admin then, that means he will be modifying the brand config
            if (this.templateName) {
                var brand_1 = this.isManagingDefaultConfig ? "" : this.getBrandDetails().brandName;
                var brandingType_1 = this.getBrandingType();
                var templateType_1 = this.getTemplateType();
                var key_1 = this.getKey();
                var isAds_1 = this.isAds();
                this.brandClientService.getDefaultBranding(this.isWidget, this.templateName, this.themeName, templateType_1, brandingType_1, key_1 ? "default" : null, isAds_1).then(function (defaultBranding) {
                    // set keys that are in the default config
                    if (defaultBranding) {
                        _this.allKeys = _this.setKeys(defaultBranding);
                        if (_this.shouldNotFilter()) {
                            _this.keys = _this.allKeys;
                        }
                        _this.brandClientService.getBranding(_this.isManagingDefaultConfig, _this.isWidget, _this.templateName, _this.themeName, brand_1, templateType_1, brandingType_1, key_1, isAds_1).then(function (model) {
                            _this.model = model;
                            _this.onModelSet();
                            _this.bindingSignaler.signal('refresh-item');
                        });
                    }
                });
            }
            this.onLoaded();
        }
        // subscribe to preview button clicks
        var self = this;
        this.messageFunc = function (event) {
            if (event.data && event.data.key == BrandingBase.SelectBrandingKey) {
                var list_1 = Enumerable.from(event.data.value);
                if (self.shouldNotFilter()) {
                    self.keys = self.allKeys;
                }
                else {
                    var filtered = Enumerable.from(self.allKeys).where(function (x) { return list_1.contains(x); }).toArray();
                    self.keys = filtered;
                }
            }
        };
        window.addEventListener('message', this.messageFunc, true);
    };
    BrandingBase.prototype.setKeys = function (model) {
        var brandingType = this.getBrandingType();
        if (brandingType) {
            return Object.keys(model);
        }
        else { // this is for ads
            return Object.keys(model[BrandingType.Images]);
        }
    };
    BrandingBase.prototype.detached = function () {
        var e_1, _a;
        window.removeEventListener("message", this.messageFunc, true);
        try {
            for (var _b = __values(this.subscriptions), _c = _b.next(); !_c.done; _c = _b.next()) {
                var s = _c.value;
                s.dispose();
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    BrandingBase.prototype.shouldNotFilter = function () {
        return false;
    };
    BrandingBase.prototype.onLoaded = function () {
    };
    BrandingBase.prototype.onModelSet = function () {
    };
    BrandingBase.prototype.getKey = function () {
        return null;
    };
    BrandingBase.prototype.isAds = function () {
        return false;
    };
    BrandingBase.SelectBrandingKey = "LOTTERY_PLATFORM_BRANDING";
    return BrandingBase;
}(ChildComponent));
export { BrandingBase };
